var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFastTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53223 15C8.53223 7.00071 15.0169 0.515991 23.0162 0.515991C31.0155 0.515991 37.5002 7.00071 37.5002 15C37.5002 22.9993 31.0155 29.484 23.0162 29.484C15.0169 29.484 8.53223 22.9993 8.53223 15ZM21.4964 15.214C21.4964 16.2062 21.987 17.1343 22.807 17.6931L26.676 20.3297C27.1774 20.6714 27.8609 20.542 28.2026 20.0405C28.5443 19.5391 28.4149 18.8556 27.9134 18.5139L25.0042 16.5314C24.1843 15.9727 23.6937 15.0446 23.6937 14.0523V9.00989C23.6937 8.40313 23.2018 7.91125 22.595 7.91125C21.9883 7.91125 21.4964 8.40313 21.4964 9.00989V15.214ZM2.02783 10.6055C2.02783 9.99871 2.51971 9.50684 3.12646 9.50684H5.23584C5.84259 9.50684 6.33447 9.99871 6.33447 10.6055C6.33447 11.2122 5.84259 11.7041 5.23584 11.7041H3.12646C2.51971 11.7041 2.02783 11.2122 2.02783 10.6055ZM2.02783 19.3945C2.02783 18.7878 2.51971 18.2959 3.12646 18.2959H5.23584C5.84259 18.2959 6.33447 18.7878 6.33447 19.3945C6.33447 20.0013 5.84259 20.4932 5.23584 20.4932H3.12646C2.51971 20.4932 2.02783 20.0013 2.02783 19.3945ZM6.33472 15C6.33472 14.3932 5.84284 13.9014 5.23608 13.9014H1.09863C0.491875 13.9014 0 14.3932 0 15C0 15.6068 0.491875 16.0986 1.09863 16.0986H5.23608C5.84284 16.0986 6.33472 15.6068 6.33472 15Z",
    fill: "#2B2F38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFastTime);
export default __webpack_public_path__ + "static/media/icon-fast-time.f1699b2903613c4c127679d51ec0dee7.svg";
export { ForwardRef as ReactComponent };